<template>
  <ts-collapse
    externClass="seat-information-group {{hasRightsChoosed && 'no-padding'}} {{isTransfer && 'transfer'}}"
    expand="{{!hasRightsChoosed}}"
  >
    <seat-information
      wx:for="{{selectSeatInfo}}"
      wx:class="{{selectSeatInfo.length > 1 && 'seat-information'}} "
      selectSeatInfo="{{item}}"
      isPreScramble="{{isPreScramble}}"
      isStudent="{{isStudent}}"
      ticketData="{{ticketData[index]}}"
      seatInfoIndex="{{index}}"
      bind:show="openPriceEstimation"
    />
  </ts-collapse>
  <view class="student-notice" wx:if="{{isStudent}}">
    <view class="student-seat-notice">
      <image class="student-seat-icon" src="https://ut-static.udache.com/webx/sfc/j9QJ2xhfiMsq3IjQ5Bdf9.png" />
      <view>温馨提示：硬座/硬卧/二等座/无座席别可享学生优惠价格最终以实际占座成功的票价为准。</view>
    </view>
  </view>
  <price-detail-info-alter
    show="{{ showPriceEstimation }}"
    title="{{ priceEstimation.title }}"
    priceDetail="{{ priceEstimation.detail }}"
    priceDetailCardTip="卧铺价格仅供参考，以实际出票结果收取费用"
    bind:close="closePriceEstimation"
  />
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { getFinalPrice } from '@/utils/money'

  createComponent({
    props: {
      hasRightsChoosed: {
        type: Boolean,
        value: false
      },
      isStudent: {
        type: Boolean,
        value: false
      }
    },
    data() {
      return {
        showPriceEstimation: false,
        priceEstimation: {}
      }
    },
    computed: {
      ...store.mapState({
        selectSeatInfo: 'train.selectSeatInfo',
        trainInfo: 'train.trainInfo',
        isTransfer: 'train.isTransfer',
        ticketData: 'train.ticketData'
      }),
      isPreScramble(){
        return this.trainInfo?.pre_scrambl_flag === 1 
      },
    },
    methods: {
      openPriceEstimation({ detail }) {
        const { seat_type_name, seatS_ticket_price, seatX_ticket_price, seatZ_ticket_price } = detail
        const seats = [
          {
            name: '上铺',
            value: seatS_ticket_price
          },
          {
            name: '中铺',
            value: seatZ_ticket_price
          },
          {
            name: '下铺',
            value: seatX_ticket_price
          }
        ].filter(({ value }) => value)
        this.priceEstimation = {
          title: `${seat_type_name}价格预估`,
          detail: {
            fee_info: [
              {
                fee_item: seats.map(({ name, value }) => {
                  return {
                    name: `${seat_type_name}${name}`,
                    value: `¥ ${getFinalPrice(value) || 0}`,
                    bold: true,
                    pixel: '14px',
                    color: '#333333'
                  }
                })
              }
            ]
          }
        }
        this.showPriceEstimation = true
      },
      closePriceEstimation() {
        this.showPriceEstimation = false
      }
    }
  })
</script>

<style scoped lang="stylus">
  .student-notice
    font-size 12px
    font-weight 400
    color #999999
    margin 12px 6px 12px 12px
    display flex
    justify-content space-between
    .student-seat-notice
      display flex
      .student-seat-icon
        width 15px
        height 11px
        position relative;
        top 2px;
        margin-right 4px;
  .seat-information-group
    background linear-gradient(180deg, #FFFFFF 69%, rgba(255, 255, 255, 0) 100%)
    margin 0 -12px
    padding 10px
    padding-bottom 0
    &.transfer
      background #fff
      margin 0
      border-radius 8px
      padding 14px 13px
    &.no-padding
      padding-top 0
    .seat-information
      &:not(:last-child)
        margin-bottom 10px
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'seat-information': '@/pages/train-detail/components/seat-information',
      'ts-collapse': '@didi/spring-ui/ts-collapse',
      'price-detail-info-alter': '@/components/price-detail-info-alter'
    }
  }
</script>